import { useItem } from '@/composables/item'
import { reviewDocumentService } from '@/services/api/reviewdocument'
import type { HpRequest, HpRequestPostPut } from '@/services/serviceTypes'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { useAlertStore } from '../system'
import { ref } from 'vue'
import storeConfigs from 'constants/storeConfigs.ts'

export const useReviewDocumentStore = defineStore(
	storeConfigs.reviewDocument.name,
	() => {
		const { items, show, update, remove, getItem, itemRemove } = useItem(
			reviewDocumentService,
			'review_documents',
			'ReviewDocument'
		)

		const accountPagination = ref({
			num: 1,
			size: 10,
			of: 'hp_id',
			od: 'ASC',
		})

		const onlyIncomplete = ref(true)

		function reviewAccount(
			reviewDocumentId: number,
			accountId: number,
			data: HpRequest<unknown>
		) {
			return reviewDocumentService
				.reviewAccount(reviewDocumentId, accountId, data)
				.then(
					({ data }) => {
						return data
					},
					(error) => {
						useAlertStore().errorAlert(error)
						return error
					}
				)
		}

		function commentSetting(
			reviewDocumentId: number,
			data: HpRequestPostPut<Api.CommentSetting>
		) {
			return reviewDocumentService.commentSetting(reviewDocumentId, data).then(
				({ data }) => {
					return data
				},
				(error) => {
					useAlertStore().errorAlert(error)
					return error
				}
			)
		}

		return {
			accountPagination,
			onlyIncomplete,
			items,
			show,
			getItem,
			itemRemove,
			update,
			remove,
			reviewAccount,
			commentSetting,
		}
	},
	{
		persist: storeConfigs.reviewDocument.persist,
	}
)

if (import.meta.hot) {
	import.meta.hot.accept(
		acceptHMRUpdate(useReviewDocumentStore, import.meta.hot)
	)
}
